<template>
  <div>
    <wtForm>
      <template slot="left">
        <SecurityCredentialFilter
          :autenticationType="autenticationType"
          :credentialType="credentialType"
        ></SecurityCredentialFilter>
      </template>

      <template slot="right">
        <SecurityCredential :autenticationType="autenticationType" :credentialType="credentialType"></SecurityCredential>
      </template>
    </wtForm>
  </div>
</template>

<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

/** COMPONENTS - LAYOUT **/
import wtForm from "@/components/forms/wtForm";

/** COMPONENTS **/
import SecurityCredential from "@/modules/security_ds/internal/security_credential/SecurityCredential";
import SecurityCredentialFilter from "@/modules/security_ds/internal/security_credential/SecurityCredentialFilter";

export default {
  name: "SecurityCredentialContainer",
  components: { wtForm, SecurityCredential, SecurityCredentialFilter },
  computed: {
    showFilter() {
      return this.$store.state.toolbars.showFilter;
    }
  },

  data: function() {
    return {
      autenticationType: [{ value: null, text: "---" }],
      credentialType: [{ value: null, text: "---" }]
    };
  },
  methods: {
    mudarTab() {
      this.$nextTick(() => {
        this.tabIndex++;
      });
    },
    getAutenticationType() {
      const urlService = "security-ds/api/internal/security-credential/";
      axios
        .post(
          `${baseApiUrl}:${baseApiPort}/${urlService}/find-all-authentication-types`
        )
        .then(res => {
          res.data.forEach(element => {
            this.autenticationType.push({
              value: element.description,
              text: element.description.split("_").join(" ")
            });
          });
        });
    },
    getCredentialType() {
      const urlService = "security-ds/api/internal/security-credential/";
      axios
        .post(
          `${baseApiUrl}:${baseApiPort}/${urlService}/find-all-credential-types`
        )
        .then(res => {
          res.data.forEach(element => {
            this.credentialType.push({
              value: element.description,
              text: element.description.split("_").join(" ")
            });
          });
        });
    }
  },
  watch: {},
  created() {
    this.$store.commit("setTypeLayout", 2);
    this.$store.commit(
      "setUrlServicesStore",
      "security-ds/api/internal/security-credential"
    );
  },
  mounted() {
    this.getAutenticationType();
    this.getCredentialType();
  },
  beforeDestroy() {
    this.$store.commit("setObjFilter", {});
    this.$store.commit("setResetFilter", false);
    this.$store.commit("setApplyFilter", false);
  }
};
</script>

<style>
</style>
